import { useState } from "react"
import Modal from "react-responsive-modal"
import { colorCode, safetyPercentage } from "../../utilities/helpers"
import PlaceSafetyCard from "../PlaceSafetyCard"
import { ReportModal } from "../ReportModal"
import "./SidebarSafetyProfile.css"

export default function SidebarSafetyProfile({
    cardPlace,
    isSidebarOpen,
    setIsSidebarOpen,
}) {
    const [openAddReport, setOpenAddReport] = useState(false)
    const onOpenReportModal = () => setOpenAddReport(true)
    const onCloseReportModal = () => setOpenAddReport(false)

    return (
        <>
            {/* Independent Toggle Button - Always Visible */}
            <button
                id="safety-sidebar-drawer-handle"
                className={`btn btn-primary position-fixed shadow-sm ${
                    isSidebarOpen ? "sidebar-open" : "sidebar-closed"
                }`}
                onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            >
                {isSidebarOpen ? (
                    <i className="bi bi-chevron-right"></i>
                ) : (
                    <span>
                        ANALYSIS <i className="bi bi-arrow-left-circle"></i>
                    </span>
                )}
            </button>

            {/* Floating Risk Profile Sidebar */}
            <div
                id="safety-sidebar"
                className={`position-fixed ${
                    isSidebarOpen ? "sidebar-open" : "sidebar-closed"
                }`}
            >
                {/* Sidebar Content */}
                <div
                    id="safety-sidebar-content"
                    className="h-100 d-flex flex-column"
                >
                    {/* Header */}
                    <div
                        id="safety-sidebar-header"
                        className="sidebar-header p-4 border-bottom"
                    >
                        <div className="d-flex align-items-center justify-content-between">
                            <div
                                id="safety-sidebar-title"
                                className="text-start"
                            >
                                <h5 className="mb-1 fw-bold text-dark">
                                    Safety Analysis
                                </h5>
                                <p className="mb-0 text-muted small">
                                    Dynamic safety metrics for{" "}
                                    {cardPlace?.name || "Location"}
                                </p>
                            </div>
                            <div className="text-end">
                                <span
                                    className={`badge bg-${colorCode(
                                        safetyPercentage(
                                            cardPlace?.overall_safety
                                        )
                                    )} fs-6 px-3 py-2 safety-sidebar-badge`}
                                >
                                    {safetyPercentage(
                                        cardPlace?.overall_safety
                                    )}
                                    %
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Scrollable Content */}
                    <div
                        id="safety-sidebar-scrollable-content"
                        className="flex-grow-1 overflow-auto"
                    >
                        {/* Safety Card Section */}
                        <div id="safety-card-analysis-section" className="p-4">
                            {cardPlace?.name ? (
                                <PlaceSafetyCard
                                    id="place-card"
                                    place={cardPlace}
                                    showAnalysis={true}
                                    version="compact"
                                />
                            ) : (
                                <div className="safety-sidebar-loading">
                                    <div
                                        className="spinner-border text-primary"
                                        role="status"
                                    >
                                        <span className="visually-hidden">
                                            Loading...
                                        </span>
                                    </div>
                                    <p className="mt-3 text-muted">
                                        Loading safety data...
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Footer */}
                    <div
                        id="safety-sidebar-footer"
                        className="sidebar-footer p-3 border-top"
                    >
                        <div className="d-flex justify-content-between align-items-center">
                            <small className="text-muted">
                                <i className="bi bi-clock me-1"></i>
                                Updated{" "}
                                {cardPlace?.updated_at
                                    ? new Date(
                                          cardPlace.updated_at
                                      ).toLocaleDateString("en-US", {
                                          year: "numeric",
                                          month: "long",
                                          day: "numeric",
                                      })
                                    : "recently"}
                            </small>
                            <div>
                                {/* Sidebar footer buttons */}
                                <button
                                    id="safety-sidebar-contribute-button"
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={onOpenReportModal}
                                >
                                    <i className="bi bi-plus-circle me-2"></i>
                                    Contribute
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Report Modal */}
            <Modal open={openAddReport} onClose={onCloseReportModal} center>
                <ReportModal
                    onClose={onCloseReportModal}
                    reportPlace={cardPlace}
                />
            </Modal>
        </>
    )
}
